import { MiniMoteComponentModule } from '../mini-mote/mini-mote.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MotesSwiperComponent } from './motes-swiper.component';
import { VirtualSwiperModule } from '../virtual-swiper/virtual-swiper.module';
import { SvgIconModule } from '../svg-icon/svg-icon.module';

@NgModule({
    imports: [
        CommonModule,
        MiniMoteComponentModule,
        VirtualSwiperModule,
        SvgIconModule
    ],
    declarations: [MotesSwiperComponent],
    exports: [MotesSwiperComponent]
})
export class MotesSwiperModule { }
